import { render, staticRenderFns } from "./dialog-organization.vue?vue&type=template&id=561a1f80&"
import script from "./dialog-organization.vue?vue&type=script&lang=js&"
export * from "./dialog-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports